export const useCmsFetch = (url, options = {}) => {
  if (url.includes('cms3') || url.includes('stage')) {
    const separator = url.includes('?') ? '&' : '?'
    url += `${separator}ak=Hs2p8cmhqeec2`
  }

  return useFetch(url, options)
}
